import React, { Component } from 'react';
import DocumentCard from 'Components/cards/DocumentCard';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    getReportNames, getProductReportNames
} from 'Apis/reportApi.js';

import './ProductReports.scss';

export class ProductReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [],
            currentValues: '',
            isLoading: false,
            isProductReportView: true,
        };
        this.attachBindings();
    }

    attachBindings() {
        this.getReportData = this.getReportData.bind(this);
        this.viewReportPage = this.viewReportPage.bind(this);
        this.getDocumentCard = this.getDocumentCard.bind(this);
    }

    componentDidMount() {
        localStorage.setItem('isProductReportView',this.state.isProductReportView);
        this.getReportData();
    }

   


    getReportData() {
         this.setState({
             isLoading: true,
         });
         return getProductReportNames()   // previously --> getReportNames
           .then((apiResponse) => {
             const reportData = apiResponse.data;
             this.setState({
               reportData: reportData,
               isLoading: false,
             });
           })
           .catch((error) => {
              this.setState({ reportData: [], isLoading: false });
             console.log('Error Occured while fetching report data', error);
           });
    }

    viewReportPage(report) {
      this.props.history.push({label: 'Product Reports', pathname:`/reports/view/${report.reportId}`, isProductReportView: this.state.isProductReportView,state :{reportName :report.reportName, pageId : report.pageListId}});
    }

    getDocumentCard(reports) {

        return (
            <div className="card-list">
                {
                    reports.map((report) => {
                        return (
                            <DocumentCard
                                key={report.reportId}
                                title={report.reportName}
                                primaryAction={() => {
                                    this.viewReportPage(report);
                                }}
                                primaryActionText='View Report'
                                secondaryOptions={[]}
                                document={report}
                                isReportIcon={true}
                            >
                            </DocumentCard>
                        );
                    })
                }
            </div>
        );
    }

    get reportCards() {
        return (
            <section className="reports-container">
                <div className="main-content--header " style={{zIndex :2}}>
                    <h1>Product Reports</h1>
                </div>
                <span className="operation-reports">
                    {
                        this.getDocumentCard(this.state.reportData)
                    }

                </span>
            </section >
        );
    }

    render() {
        window.document.title = 'Product Reports';
        return (
            <section className="reports-container">
                {
                    (!this.state.isLoading) ? (
                        this.reportCards) :
                        (
                            this.state.isLoading && (
                                <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                                    <BVLoader20 />
                                </div>
                            )
                        )
                }
            </section>
        );
    }
}

ProductReports.propTypes = {

};

ProductReports.defaultProps = {

};


const mapStateToProps = (state) => ({ 
});

const mapDispatchToProps = (dispatch) => {
return {
};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductReports));
